<!--
 * @Author: vince
 * @Date: 2021-09-05 16:03:44
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-10 01:27:21
 * @Description:
-->
<template>

  <div>
    <div>
    <breadcrumb></breadcrumb>
  </div>
    <el-main v-loading="loading">
      <div class="bg-white pa-md">
        <el-form class="full-width mb-2px" :model="filterForm">
          <div class="filter-bar pa-none">
            <el-form-item class="mb-none">
              <el-input v-model="filterForm.keyword" size="small" clearable placeholder="搜索培训名称或教师姓名" style="width: 270px"
                        @change="refresh" @keydown.enter="refresh">
              </el-input>
            </el-form-item>
            <el-form-item class="mb-none" label="培训级别">
              <DicSelector dicType="trainLevel" v-model="filterForm.classify3" ref="dictor" @change="refresh">
              </DicSelector>
            </el-form-item>
            <el-form-item class="mb-none" label="校区">
              <school-selector checkAll v-model="filterForm.schoolTemp" @change="refresh"></school-selector>
            </el-form-item>
            <div class="space"></div>
          </div>
        </el-form>


        <el-table :data="tableData" v-loading="loading" header-cell-class-name="tbh" style="width: 100%">
          <el-table-column prop="createName" label="教师" align="left"></el-table-column>
          <el-table-column prop="actTitle" label="培训标题" align="left"></el-table-column>
          <el-table-column prop="classify3" label="培训级别" align="center">
            <template slot-scope="scope">
              {{ $refs.dictor.getNameByCode(scope.row.classify3) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期" align="center"></el-table-column>
          <el-table-column prop="id" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row)">审核</el-button>
            </template>
          </el-table-column>
          <pagination class="mb-md mr-md" slot="append" :pageObj="filterForm" @handleSizeChange="handleSizeChange"
                      @handleCurrentChange="handleCurrentChange"></pagination>
        </el-table>
      </div>

      <el-dialog title="校外培训审核" :visible.sync="dialog" @closed="onDialogClose">
        <el-form ref="ruleForm" :model="form" class="content-box" label-width="125px" size="small" disabled>
          <el-form-item label="培训标题" prop="actTitle">
            <el-input v-model="form.actTitle"></el-input>
          </el-form-item>
          <el-form-item label="培训级别" prop="classify3">
            <DicSelector dicType="trainLevel" v-model="dicTemp"></DicSelector>
          </el-form-item>
          <el-form-item label="培训时间" prop="endDate">
            <el-date-picker v-model="dateRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="培训地点" prop="address">
            <el-input type="textarea" v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="培训时长" prop="actTime">
            <el-input v-model="form.actTime"></el-input>
          </el-form-item>
          <el-form-item label="培训体会或反馈" prop="actContent">
            <el-input v-model="form.actContent" maxlength="200" show-word-limit type="textarea"
                      :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="培训通知单" prop="actNotice">
            <uploader :file-list.sync="form.actNotices" multiple></uploader>
          </el-form-item>
          <el-form-item label="活动图片" prop="actPicture">
            <uploader :file-list.sync="form.actPictures" multiple list-type="picture-card"></uploader>
          </el-form-item>
        </el-form>
        <el-form ref="formEx" :model="formExamine" :rules="rules" class="content-box" label-width="125px" size="small">
          <el-form-item label="审核意见" prop="checkDesc">
            <el-radio v-model="formExamine.checkStatus" :label="1">通过</el-radio>
            <el-radio v-model="formExamine.checkStatus" :label="2">不通过</el-radio>
            <el-input v-if="formExamine.checkStatus == 2" type="textarea" v-model="formExamine.checkDesc"
                      placeholder="请输入不通过的原因"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer text-center">
          <el-button @click="dialog = false">取 消</el-button>
          <el-button type="primary" @click="onSave" :loading="saving">确 定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import DicSelector from "../../components/school/dicSelector.vue";
import pagination from "../../components/Pagination.vue";
import SchoolSelector from "../../components/school/schoolSelector.vue";
import { postData, postJson } from "../../http/fetch.js";
import { mapGetters, mapState } from "vuex";
import uploader from "../../components/school/uploader.vue";

export default {
  name: "extraTrainingExamine",
  data() {

    var validateReason = (rule, value, callback) => {

      if (this.formExamine.checkStatus === 2 && value === '') {
        callback(new Error('请输入审核不通过的原因'));
      } else {
        callback();
      }
    };
    return {

      saving: false,
      loading: false,
      tableData: [],
      filterForm: {
        keyword: null,
        classify3: null,
        school: null,
        total: 0,
        current: 1,
        size: 10,
      },
      dialog: false,
      dicList: [],
      formExamine: {
        checkDesc: "",
        checkStatus: 1,
      },
      rules: {
        checkDesc: [{
          validator: validateReason, trigger: 'blur'
        }]
      },
      form: {
        "actCode": null,//活动代码
        "actContent": "",//培训方式
        "actNotices": [],//培训通知单
        "actPictures": [],//活动图片
        "actTime": "",//培训时长
        "actTitle": "",//培训标题
        "address": "",//培训地点
        "classify3": "",//	培训级别1:0:国家级,1:市级,2:区级,3:校级,4:专项培训
        "endDate": "",//	截止日期（yyyy-MM-dd HH:mm:ss）
        "id": null,//活动ID,不为空则更新
        "operatorId": "",//	操作者ID
        "orgCode": "",//集团代码
        "schoolCode": "",//校区代码
        "startDate": "",//开始日期（yyyy-MM-dd HH:mm:ss）
        "faceAttaches": "",
        checkStatus: null,
      },
    };
  },
  components: {
    Breadcrumb,
    SchoolSelector,
    pagination,
    DicSelector,
    uploader
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["schoolCode"]),
    dateRange: {
      get() { return [this.form.startDate, this.form.endDate] },
      set(v) {
        this.form.startDate = v[0];
        this.form.endDate = v[1];
      }
    },
    dicTemp: {
      get() {
        return {
          dicCode: this.form.classify3 + ''
        }
      },
      set(v) {
        this.form.classify3 = (v ? v.dicCode + '' : '')
      }
    }

  },
  mounted() {
    this.getData();
  },
  methods: {
    onSave() {
      this.$refs.formEx.validate((valid) => {
        if (valid) {
          this.saving = true;
          postJson('/training/checkExtraTrainingInfo', {
            "checkDesc": this.formExamine.checkDesc,
            "checkName": this.userInfo.userName,
            "checkStatus": this.formExamine.checkStatus,
            "id": this.form.id,
            "operatorId": this.userInfo.userId
          }).then(res => {
            this.dialog = false;
            this.$message.success("操作成功！")
            this.refresh();
          }).finally(() => {
            this.saving = false;
          })
        } else {
          return false;
        }
      });
    },


    onDialogClose() { },
    refresh() {
      this.filterForm.current = 1;
      this.getData();
    },
    goDetail(row) {
      this.form = { ...row };
      this.dialog = true;
    },
    getData() {
      this.loading = true;
      postJson('/training/getUncheckExtraTrainingInfoList', {
        "classify3": this.filterForm.classify3 ? this.filterForm.classify3.dicCode : null,
        "keyword": this.filterForm.keyword,
        "orgCode": this.userInfo.orgCode,
        "pageNum": this.filterForm.current,
        "pageSize": this.filterForm.size,
        "queryEndTime": this.filterForm.queryEndTime,
        "queryStartTime": this.filterForm.queryStartTime,
        "schoolCode": this.filterForm.schoolTemp ? this.filterForm.schoolTemp.schoolCode : this.schoolCode
      }).then((res) => {
        this.tableData = res.records;
        this.filterForm.size = res.size;
        this.filterForm.total = res.total;
        this.filterForm.current = res.current;
      }).finally(() => {
        this.loading = false;
      })
    },

    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;

    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;

    },

  },
};
</script>

<style lang="less">
.el-input-group__append {
  cursor: pointer;
  background: @color;
  color: #fff;
}
</style>
